<template>
  <div class="details">
    <div class="info">
      <div class="container info_Box">
        
        <div class="info_l">
          <h2>
            <span>{{ content.name }}</span>
            <span>{{ content.salary }} | {{ content.work_l }}</span>
          </h2>
          <p>
            <span>类别：{{ content.job_cate_name }} | </span>
            <span>学历：{{ content.education }} | </span>
            <span>人数：{{ content.people }} </span>
          </p>
        </div>
        <div class="info_r">
          <el-button
            type="primary"
            v-if="!content.is_delivery_job"
            @click="ToApply"
            >申请职位</el-button
          >
          <el-button type="success" @click="ToUser" v-else
            >简历已投递</el-button
          >
        </div>
      </div>
    </div>
    <div class="details_box">
      <div class="container">
        <div style="height: 0.23rem"></div>
        <DetailsSlot>
          <h2 slot="h2">岗位职责：</h2>
          <div slot="con" v-html="content.j_desc"></div>
        </DetailsSlot>
        <DetailsSlot>
          <h2 slot="h2">招聘要求：</h2>
          <div slot="con" v-html="content.requirement"></div>
        </DetailsSlot>
        <DetailsSlot>
          <h2 slot="h2">福利待遇：</h2>
          <div slot="con" v-html="content.welfare"></div>
        </DetailsSlot>
        <div class="btn">
          <el-button
            v-if="!content.is_delivery_job"
            type="primary"
            plain
            @click="ToApply"
            >申请职位</el-button
          >
          <el-button v-else type="success" @click="ToUser"
            >简历已投递</el-button
          >
          <el-button type="success" @click="ToUser">返回</el-button>
        </div>
        <div style="height: 0.3rem"></div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsSlot from "@/components/DetailsSlot.vue";
import StepJs from "./mixins/step";
export default {
  name: "Details",
  mixins: [StepJs],
  props: {},
  data() {
    return {
      content: {},
    };
  },
  computed: {},
  created() {
    this.getContent();
  },
  mounted() {},
  watch: {
    // getContent: function () {
    //   return this.is_delivery_job;
    // },
  },
  methods: {
    ToUser() {
      this.$router.push("/user/already");
    },

    // 获取岗位详情内容
    getContent() {
      let Pid = this.$route.query.id;
      this.$http.get("/api/Job/details/" + Pid).then((res) => {
        console.log("this.res", res.content);
        this.content = res.content;
      });
    },
    // 申请职位
    ToApply() {
      let Pid = this.$route.query.id;
      this.$router.push({
        path: "/apply",
        query: {
          id: Pid,
        },
      });
      // if (
      //   this.$store.state.user.token == "" ||
      //   this.$store.state.user.token == null
      // ) {
      //   // 提交成功触发
      //   this.$message({
      //     message: "请先登录后再申请",
      //     type: "error",
      //     duration: 2000,
      //     offset: 200,
      //   });
      //   this.$router.push("/user/login");
      // } else {
      //   let Pid = this.$route.query.id;
      //   let userId = this.$store.getters.userInfo.user.user_id;
      //   this.$http
      //     .post("/api/Job/delivery", { user_id: userId, job_id: Pid }, true)
      //     .then((res) => {
      //       // 提交成功触发
      //       this.$message({
      //         message: "提交申请成功",
      //         type: "success",
      //         duration: 2000,
      //         offset: 200,
      //       });
      //       this.$store.dispatch("user/getInfo").then(() => {
      //         this.getContent();
      //       });
      //     });
      // }
    },
  },
  components: {
    DetailsSlot,
  },
};
</script>

<style lang="less" scoped>
.details {
  margin-top: 0.8rem;
  .info {
    width: 100%;
    height: 1.5rem;
    background-color: #ff7f00;
    .info_l {
      float: left;
      h2 {
        font-size: 0.18rem;
        color: #fff;
        padding-top: 0.5rem;
        span:nth-child(2) {
          margin-left: 0.8rem;
        }
      }
      p {
        font-size: 0.12rem;
        color: #eee;
        padding-top: 0.1rem;
      }
    }
    .info_r {
      float: right;
      line-height: 1.5rem;
      button {
        width: 0.9rem;
        height: 0.36rem;
        padding: 0;
        span {
          line-height: 0.36rem;
          font-size: 0.12rem;
        }
      }
    }
  }
  .details_box {
    background-color: #e9e9e9;
    .details_con {
      .det_box {
        div {
          font-size: 0.14rem;
          div {
            font-size: 0.14rem;
          }
        }
      }
    }
  }
}
.btn {
  display: flex;
  justify-content: center;
  margin: 0.5rem 0;
}
@media only screen and (max-width: 766px) {
  .details {
    margin-top: 1.4rem;
    .info {
      height: 2.8rem;
      .info_Box {
        display: flex;
        flex-flow: column;
        padding: 0 0.26rem;

        .info_l {
          margin-top:0.5rem;
          h2 {
            font-size: 0.36rem;
            padding-top: 0;
          }
          p {
            font-size: 0.24rem;
          }
        }
        .info_r {
          button {
            width: 1.8rem;
            height: 0.68rem;
          }
        }
      }
    }
    .details_box {
      background-color: #e9e9e9;
      .details_con {
        width: 95%;
        margin: 0 auto;
        margin-top: 0.23rem;
        .det_box {
          div {
            font-size: 0.24rem;
            div {
              font-size: 0.24rem;
            }
          }
        }
      }
    }
  }
}
</style>
